module.exports = __webpack_public_path__ + "img/icon-ticket_time.4ac33090.svg";